import settings from '../conf/settings';
import moment from 'moment-timezone';
import UAParser from 'ua-parser-js';
import { LOG_LEVELS, LOGGING } from "./enums";
import { _LTracker } from 'loggly-jslogger';
import { get, pick } from "lodash/object";

(function(){
  // initialize and configure loggly
  _LTracker.push({
    'logglyKey': '63517b01-877a-4a1f-80f5-c02d895fa141',
    'sendConsoleErrors' : true,
    'useDomainProxy' : true,
    'tag' : document.location.hostname === 'localhost' ? `com.sipree.ui.tigris.recipient-v2,local,loggly-jslogger` : `com.sipree.ui.tigris.recipient-v2,loggly-jslogger,${settings.environment.DEPLOYMENT_ENVIRONMENT}`,
  });

  logger({
    event: LOGGING.EVENTS.PAYWALL_VISITED,
    url: window.location.origin,
  })
})();

function getPaymentIdFromUrl() {
  const url = window.location.href;
  const withPotentialValidationData = url.substring(url.lastIndexOf('/') + 1);
  const paymentId = withPotentialValidationData.substring(0, withPotentialValidationData.indexOf('?'));
  return paymentId;
}

function getBaseLogData () {
  const baseLogData = {
    timestamps: {
      pdt: moment().tz('America/Los_Angeles').format('dddd, MMMM Do YYYY, h:mm:ssa (z)'),
      utc: moment().utc().format('dddd, MMMM Do YYYY, h:mm:ssa (z)'),
      local: moment().local().format('dddd, MMMM Do YYYY, h:mm:ssa')
    },
    clientInfo: (new UAParser()).getResult(),
  };

  const paymentId = getPaymentIdFromUrl();
  if(paymentId) {
    baseLogData.paymentId = paymentId;
  }

  return baseLogData;
}

export function logger (data, level = LOG_LEVELS.INFO) {
  const logData = {
    level,
    ...getBaseLogData(),
    ...data,
  };

  _LTracker.push(logData);
}

window.onerror = function(message, source, lineno, colno, error) {
  // this top-level error handler will catch any errors that are not caught by the react error boundary (eg uncaught javascript errors that happen outside of react lifecycle and render methods)
  // errors that are thrown inside a react lifecyle or render methods will be caught by the <ErrorBoundary /> which wraps the top-level app
  console.error(message, error)

  const logData = {
    level: LOG_LEVELS.ERROR,
    ...getBaseLogData(),
    error: {
      message,
      source,
      lineno,
      colno,
      error,
    }
  };

  window._LTracker.push(logData);
  return true;
};

export const getFormattedApplicationState = applicationState => ({
  ...pick(applicationState, ['selectedPaymentNetwork', 'selectedLanguage']),
  payment: applicationState.payment && pick(applicationState.payment, ['id', 'programId', 'status', 'availablePaymentNetworks', 'paymentNetwork']),
  programName: get(applicationState, 'configuration.programName'),
  programId: get(applicationState, 'payment.programId'),
});

export const logUiError = (errorType, applicationState, additionalLogData) => {
  const dataForLogs = {
    programName: get(applicationState, 'configuration.programName'),
    programId: get(applicationState, 'payment.programId'),
    error: {
      errorType,
      applicationState: getFormattedApplicationState(applicationState),
      ...additionalLogData,
    }
  };

  logger(dataForLogs, LOG_LEVELS.ERROR);
};

export const logHttpError = (httpRequestException, applicationState, additionalLogData) => {
  const {errorType, serverResponse} = httpRequestException;

  const dataForLogs = {
    error: {
      errorType,
      serverResponse: {
        ...pick(serverResponse, ['data', 'status', 'statusText', 'request', 'error', 'code', 'message']),
        config: pick(serverResponse.config, ['url', 'method', 'data'])
      },
    },
    programName: get(applicationState, 'configuration.programName'),
    programId: get(applicationState, 'payment.programId'),
    applicationState: getFormattedApplicationState(applicationState),
    ...additionalLogData,
  };

  logger(dataForLogs, LOG_LEVELS.ERROR);
};
